<template>
  <v-dialog
    v-model="display"
    :width="width"
  >
    <v-card>
      <v-card-title class="text-h6 prompt-title-bar lighten-2">
        <v-row class="pt-0 pb-0">
          <v-col cols="9" class="text-left">
            {{ title }}
          </v-col>
          <v-spacer></v-spacer>
          <v-col cols="1" class="text-center">
            <v-icon color="white" @click="close">
              mdi-close
            </v-icon>
          </v-col>
        </v-row>
        
        
      </v-card-title>
      <br>
      <v-card-text class="prompt-text">
        <slot></slot>
      </v-card-text>
    
      <v-card-text 
        v-if="res" 
        class="status-message"
        >
        <div :class="res.code">{{ res.msg }}</div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'Dialog',
  props: {
    display: {
      type: Boolean,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    state: {
      type: Boolean,
      required: true
    },
    res: {
      type: Object,
      required: false,
      default: () => {}
    },
    width: {
      type: Number,
      required: false,
      default: 600
    }
  },
  data() {
    return {
      dialog: false,
      loading: false,
      finished: false
    }
  },
  watch: {
    state() {
      if(this.state) {
        this.loading = false;
        this.finished = true;
      }
    }
  },
  mounted() {
    this.dialog = this.display;
  },
  methods: {
    close() {
      this.finished = false;
      this.$emit('close');
    }
  }
}
</script>

<style lang="scss" scoped>
  .prompt-title-bar {
    background: #0f74bb;
    color: white;
  }
  .prompt-text {
    font-size: 1em;
  }
  .status-message {
    text-align: center;
    font-size: 1em;
  }
  .green {
    color: green !important;
    background-color: white !important;
  }
  .red {
    color: red !important;
    background-color: white !important;
  }
</style>